import AnyAction from 'store/anyActions';
import QueuedTasksState from './queuedTasks.state';
import QueuedTasksTypes from './queuedTasks.types';

const defaultState = {
    queuedTasksContacts: [],
    queuedTasksReplyText: {},
    queuedTasksContactAttributes: {},
    queuedTasksProcessing: false,
    queuedTasksProcessingShowModal: false,
    queuedTasksProcessingContacts: [],
    queuedTasksProcessingStatuses: {
        completed: 0,
        processing: 0,
        errored: 0,
        actioned: 0,
    },
};

export default function (state: any = defaultState, action: AnyAction): QueuedTasksState {
    switch (action.type) {
        case QueuedTasksTypes.UPDATE_ACW_ATTRIBUTES_QUEUED_TASKS:
            return {
                ...state,
                queuedTasksContactAttributes: { ...state.queuedTasksContactAttributes, ...action.payload.acwAttributes },
                queuedTasksContacts: action.payload.IDs
            };
        case QueuedTasksTypes.CLEAR_ACW_ATTRIBUTES_QUEUED_TASKS:
            return {
                ...state,
                queuedTasksContactAttributes: {},
                queuedTasksContacts: [],
            };
        case QueuedTasksTypes.SET_QUICK_REPLY_RICH_TEXT:
            return { ...state, quickReplyPlainText: {}, quickReplyRichText: action.payload };
        case QueuedTasksTypes.SET_QUICK_REPLY_PLAIN_TEXT:
            return { ...state, quickReplyRichText: {}, quickReplyPlainText: action.payload };
        case QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING:
            return { ...state, queuedTasksProcessing: action.payload };
        case QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_SHOW_MODAL:
            return { ...state, queuedTasksProcessingShowModal: action.payload };
        case QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_CONTACTS:
            return { ...state, queuedTasksProcessingContacts: action.payload };
        case QueuedTasksTypes.SET_QUEUED_TASK_PROCESSING_STATUSES:
            return { ...state, queuedTasksProcessingStatuses: action.payload };
        default:
            return state;
    }
}
